import { ActivatedRoute } from "@angular/router";
import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { LocalStorageHelpers } from "app/helpers";
import { BsModalRef, BsModalService } from "ngx-bootstrap";

@Component({
  selector: "app-on-boarding",
  templateUrl: "./on-boarding.component.html",
  styleUrls: ["./on-boarding.component.scss"],
})
export class OnBoardingComponent implements OnInit {
  @ViewChild("onboarding") onboarding: TemplateRef<any>;
  modalRef: BsModalRef;
  constructor(
    private modalService: BsModalService,
    private ls: LocalStorageHelpers,
    private router: ActivatedRoute,
  ) { }
  swiper: any = null;

  ngOnInit() {
    this.ls.remove("onboarding");
    return;
  }
}
